import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class DevicesRegistrationService {

  static getRoot() {
    return ROOT;
  }

  static registerDevice(deviceRegistrationRequest) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}registrations`, deviceRegistrationRequest).then((response) => {
        resolve({ response: response.data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static bulkRegisterDevices(deviceType, csvFile) {
    const deviceTypeBlob = new Blob([JSON.stringify(deviceType)], {
      type: 'application/json'
    });

    let formData = new FormData();
    formData.append('csvFile', csvFile);
    formData.append('deviceType', deviceTypeBlob);

    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}registrations/bulk`, formData).then((response) => {
        resolve(response.data);
      }).catch(err => {
        reject(err);
      })
    })
  }

  static getRegistrations(includeDeregistered = false) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}registrations?includeDeregistered=${includeDeregistered}`).then((response) => {
        resolve({ response: response.data });
      }).catch((err) => {
        reject(err);
      });
    });    
  }

  static deregisterDevice(deviceId) {
    return new Promise((resolve, reject) => {
      axios.delete(`${ROOT}registrations/deregister?deviceId=${deviceId}`).then((data) => {
        resolve({ device: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default DevicesRegistrationService;
